module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_result":"結果が見つかりませんでした。","no_more_data":"これ以上データがありません。","err_msg":"最新のデータが取得できませんでした。<br>電波状況などが悪い可能性があります。<br>電波状況をご確認の上、再度お試しください。"}}')
  delete Component.options._Ctor
}
